<template>
    <div class="tc-outline-button-square"
         @click.stop="$emit('click')">
        <slot name="icon"></slot>
    </div>
</template>

<script>
export default {
    name: 'SquareOutlineButton',
    props: [
        'text',
    ],
    emits: [
        'click',
    ],
};
</script>

<style scoped lang="scss">
.tc-outline-button-square {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 40px;
    box-sizing: border-box;
    cursor: pointer;
    user-select: none;
    color: #00458D;
    border: 1px solid currentColor;
    transition: 0.3s ease all;
}

.tc-outline-button-square:active {
    color: #0170E3;
}

</style>
